import { Forms } from "../../components/backgrounds/Forms";
import { Steps } from "../../components/buttons/Steps";
import { Primary } from "../../components/buttons/Primary";
import TagManager from "../../components/googleTag/TagManager";

export function CrezuPage() {

  const generarNumeroAleatorioDe10Cifras = () => {
    const min = 1000000000; // Valor mínimo con 10 dígitos
    const max = 9999999999; // Valor máximo con 10 dígitos
    const numeroAleatorio = Math.floor(Math.random() * (max - min + 1)) + min;
    return numeroAleatorio;
  }

  //const urlSolcredito = `https://solcredito.co/?xc=613d9c905509e8147440cc7ea8d7d04d969552c8&utm_source=galilea&utm_medium=affiliate&utm_campaign=galilea_sol_co&xt={g-00}{${generarNumeroAleatorioDe10Cifras()}}&aff_id={galilea_traffic}`;
  const urlCrezu = "https://track.leadbazaar.co/click?pid=6180&offer_id=389";

  return (
    <div className="bg-purpleLight h-full min-h-screen">
      <TagManager />
      <Steps
        estado1="complete"
        estado2="complete"
        estado3="current"
        estado4="upcoming"
      />
      <Forms
        title="Tenemos una oferta de crédito distinta para ti"
        description={"¡Felicidades! Tienes pre-aprobado un cupo por $1.500.000"}
        form={
          <div className="shadow-lg overflow-hidden rounded-md">
            <div className="px-4 py-5 bg-white sm:p-6">
              <div className="lg:px:4 pb-10">
                <span>
                  En estos momentos no podemos atender tu solicitud en Galilea, sin embargo, uno de nuestros aliados te ha pre-aprobado un cupo por valor de $1.500.000. Puedes ingresar ahora mismo a su web para continuar con el desembolso, estaremos atentos a la evolución de tu solicitud, gracias por confiar en nosotros.
                </span>
              </div>

              <div className="py-10 grid justify-items-center ">
                <img className="w-60 h-auto" src="/png/crezu.png" alt="crezu-galilea" />
              </div>

            </div>
            <div className="px-4 py-6 flex justify-end bg-white text-right sm:px-6">
              {/* <a href={urlCrezu} className="w-56 md:w-56"> */}
              <a href={urlCrezu} className="w-56 md:w-56">
                <Primary text="Continuar solicitud" />
              </a>
            </div>
          </div>
        }
      />
    </div>
  );
}
